import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as registrationSelector from "../../../../../common/selectors/registration";
import * as registrationAction from "../../../../../common/actions/registration";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import AuthManager from "../../../../../utils/AuthManager";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CustomToast from "../../../../components/CustomToast";
import Color from "../../../../../utils/Color";

class MobileNoRequired extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      mobileNumber: "",
      nric: "",
      localNric: "",
      localClientMobile: "",
      mobileNo: "",
      countryCode: "",
      customToastStatus: false,
      toastMessage: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrieveNric().then((value) => {
      if (value) {
      
        this.setState({ localNric: value });
     
      }
    });
    await AuthManager.retrieveClientMobileNo().then((value) => {
      if (value) {
       
        this.setState({ localClientMobile: value });
      
      }
    });
    //const { clientMobileNo, nric } = this.props.location.state;

    //this.setState({ mobileNumber: clientMobileNo });
    //this.setState({ nric: nric });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate = (prevProps, prevState) => {
    
    const {
      
      promptMobilePhoneInputData,
      promptMobilePhoneInputLoading,
      promptMobilePhoneInputStatus,
    } = this.props;
    

    if(prevProps.promptMobilePhoneInputData !== promptMobilePhoneInputData ){
      const { history } = this.props;
      var countryCode =
      "+" + this.state.mobileNo.toString().slice(0, this.state.countryCode);
      var mobileNo = this.state.mobileNo
      .toString()
      .slice(this.state.countryCode, 20);
      const otpReference = registrationSelector.promptMobilePhoneInputDataOtpReference(
        promptMobilePhoneInputData
      );
      const msg = registrationSelector.promptMobilePhoneInputDataMsg(
        otpReference
      );
      if(msg === "Invalid mobile number."){
        this.setState({ customToastStatus: true });
        this.setState({
          
          toastMessage: msg,
        });
      }else if(msg === "Sorry, your request cannot be processed. Please Whatsapp our Customer Care at +65 6887 8777."){
        this.setState({ customToastStatus: true });
        this.setState({
          
          toastMessage: msg,
        });
      }else if(!promptMobilePhoneInputData.Success){
        this.setState({ customToastStatus: true });
        this.setState({
          
          toastMessage: 'Verification failed.',
        });
      }else{
        AuthManager.setClientMobileNo(mobileNo);
        AuthManager.setMobileCountryCode(countryCode);
        AuthManager.setOtpReference(otpReference);
        AuthManager.setNric(this.state.localNric);
        
        history.push("/RegistrationOtp");
      }
      
    }
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onClickBack = () => {
   const {history} = this.props;
   history.push("/Registration")
  }

  // onClickSubmitPhoneNumber = () => {
  //   const { promptMobilePhoneInput } = this.props;
  //   //registrationOtpRequest(this.state.localNric);
  //   let submitData = {
  //     mobile_country_code:
  //       "+" + this.state.mobileNo.toString().slice(0, this.state.countryCode),
  //     mobile_number: this.state.mobileNo
  //       .toString()
  //       .slice(this.state.countryCode, 20),
  //   };
  //   var countryCode =
  //     "+" + this.state.mobileNo.toString().slice(0, this.state.countryCode);
  //   var mobileNo = this.state.mobileNo
  //     .toString()
  //     .slice(this.state.countryCode, 20);
  
  //   promptMobilePhoneInput(this.state.localNric,mobileNo, countryCode);
  // };

  onClickSubmitPhoneNumber = async () => {
    const { promptMobilePhoneInput } = this.props;
  
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_REGISTRATION_OTP" }
      );
  
      // if (!recaptchaToken) {
      //   this.setState({
      //     customToastStatus: true,
      //     toastMessage: "Unable to verify reCAPTCHA. Please try again.",
      //   });
      //   return;
      // }
  
      // Prepare the submission data
      let submitData = {
        mobile_country_code:
          "+" + this.state.mobileNo.toString().slice(0, this.state.countryCode),
        mobile_number: this.state.mobileNo
          .toString()
          .slice(this.state.countryCode, 20),
        recaptcha_token: recaptchaToken, // Include the reCAPTCHA token
      };
  
      var countryCode =
        "+" + this.state.mobileNo.toString().slice(0, this.state.countryCode);
      var mobileNo = this.state.mobileNo
        .toString()
        .slice(this.state.countryCode, 20);
  
      // Call the promptMobilePhoneInput function
      promptMobilePhoneInput(this.state.localNric, mobileNo, countryCode,recaptchaToken);
    } catch (error) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Error during reCAPTCHA verification. Please try again.",
      });
    }
  };
  

  handleChangeMobile = (value, data, event, formattedValue) => {
    this.setState({ countryCode: data.countryCode.length });
    this.setState({ mobileNo: value });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickSubmitPhoneNumber();
    }
  };

  renderChildren = () => {
    const { classes } = this.props;

    return (
      <div>
        <CustomText design={classes.headerTextStyle}>
          Mobile Number Required
        </CustomText>
        <div style={{ marginTop: 50, marginBottom: 50 }}>
          <CustomText design={classes.mobileTitleTextStyle}>
            Enter Your Mobile Number
          </CustomText>
          <div>
            {/* <CustomText design={classes.mobileNoTextStyle}>
              {this.state.localClientMobile}
            </CustomText> */}
            <PhoneInput
              country={"sg"}
              value={this.state.mobileNo}
              onChange={this.handleChangeMobile}
              enableAreaCodeStretch
              countryCodeEditable={false}
              enableSearch={true}
              onKeyDown={this.handleKeypress}
              //onChange={phoneNo => this.setState({ phoneNo })}
            />
          </div>
        </div>
        <div style={{ paddingRight: "1em", display: "inline-block" }}>
        <CustomButton
          title={"Back"}
          design={classes.backButton}
          textstyle={classes.backButtonTextStyle}
          onClick={this.onClickBack}
        />
      </div>
      <div style={{ display: "inline-block" }}>
        <CustomButton
          title={"Submit"}
          design={classes.buttonStyle}
          onClick={this.onClickSubmitPhoneNumber}
        />
      </div>

        {/* <CustomButton
          title={"Back"}
          design={classes.buttonStyle}
          onClick={this.onClickSubmitPhoneNumber}
        />
        <CustomButton
          title={"Submit"}
          design={classes.buttonStyle}
          onClick={this.onClickSubmitPhoneNumber}
        /> */}
      </div>
    );
  };

  render() {
    const { classes, registrationOTPReqLoading,promptMobilePhoneInputLoading } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
        {promptMobilePhoneInputLoading ? <LoadingOverlay loading={true} /> : false}
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  mobileTitleTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
  },
  mobileNoContainer: {
    width: 140,
    borderRadius: 5,
    backgroundColor: "#eaeef2",
    marginTop: 15,
    marginBottom: 35,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 5,
    paddingBottom: 5,
  },
  mobileNoTextStyle: {
    fontSize: 21,
    ...getFontWeight("bold"),
    color: "#2c3034",
  },
  buttonStyle: {
    width: 120,
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
});

function mapStateToProps(state) {
  return {
    promptMobilePhoneInputData: selector.promptMobilePhoneInputData(state),
    promptMobilePhoneInputLoading: selector.promptMobilePhoneInputLoading(
      state
    ),
    promptMobilePhoneInputStatus: selector.promptMobilePhoneInputStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    promptMobilePhoneInput: (nric,mobileNo, mobileCountryCode,recaptchaToken) =>
      dispatch(
        registrationAction.promptMobilePhoneInput(nric,mobileNo, mobileCountryCode,recaptchaToken)
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(MobileNoRequired)));
